export { default as OmnichannelPage } from './OmnichannelPage.vue'
